/**
 * Type-ahead matching for option comboboxes (staff, offices, ...).
 *
 * Every word typed must be the start of some word in the option's label, in any order and ignoring case and
 * punctuation. So for "Laib, Kelly": "kelly laib", "Laib Kelly", "kel", "laib, k" all match; "elly" does not.
 * Hyphens/apostrophes split words too, so "Smith-Jones, Kelly" matches "jones" and "O'Brien" matches "brien".
 */
const words = (value: string): string[] =>
    value
        .toLowerCase()
        .split(/[^\p{L}\p{N}]+/u)
        .filter(Boolean);

export const matchesOption = (label: string, query: string): boolean => {
    const terms = words(query);
    if (terms.length === 0) return true;
    const labelWords = words(label);
    return terms.every((term) => labelWords.some((word) => word.startsWith(term)));
};
